var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({ '--colorA': _vm.currentTheme.colorA, '--colorB': _vm.currentTheme.colorB }),attrs:{"id":"app"}},[_c('nav-header'),_c('router-view'),_c('csFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }